import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Container = styled.article`
    width: 17rem;
    height: 16rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: .5rem;
    box-shadow: 0 .1rem .5rem 0 rgba(0, 0, 0, .3);
    background-color: #FFF;
    border: 2pt solid ${({select}) => select ? variables.COLOR_BLUE : 'transparent'};
    cursor: pointer;
    position: relative;
    transition-duration: .1s;
    transition-property: all;
    transition-timing-function: ease-in;
  
    ${({select}) => select && `
        :after {
            width: 100%;
            height: 2.2857142857142856rem;
            content: 'Selecionado';
            background-color: ${variables.COLOR_BLUE};
            display: flex;
            align-items: center;
            justify-content: center;
            color: #FFF;
            font-weight: 700;
            font-size: 0.8571428571428571rem;
            position: absolute;
            bottom: 0;
        }
    `}
  
    img {
        width: ${({select}) => select ? '3.722857142857143rem' : '5.411428571428572rem'};
        margin-bottom: 2.1871428571428573rem;
        transition-duration: .3s;
        transition-property: all;
        transition-timing-function: ease-in;
    }
  
    hgroup, h1, h6 {
        margin: 0;
        padding: 0;
        text-align: center;
        transition-duration: .3s;
        transition-property: all;
        transition-timing-function: ease-in;
    }
  
    h1 {font-size: 1.2857142857142858rem;}
  
    h6 {
        font-size: 1rem;
        span {
            font-weight: bold;
        }
    }
    
    @media (max-width: ${variables.TABLET}) {
        width: 16.001428571428573rem;
        height: 14.002142857142857rem;
    
        h1 {font-size: 1rem;}
        h6 {font-size: 0.8571428571428571rem;}
    }
`;